module.exports = __webpack_public_path__ + "frontend/images/green/carousel/static/0.png?97b0567d8f5a9a04ad2499fa844c9d95";